/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { OasOperation } from '../../openapi/models/OasOperation';
import { OasParameter } from '../../openapi/models/OasParameter';
import { Oas20Parameter } from '../../openapi/v2/models/Oas20Parameter';
import { NewRequestBodyCommand } from './NewRequestBodyCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends NewRequestBodyCommand
 * @class
 */
export class NewRequestBodyCommand_20 extends NewRequestBodyCommand {
    public constructor(operation? : any) {
        if(((operation != null && operation instanceof <any>OasOperation) || operation === null)) {
            let __args = arguments;
            super(operation);
        } else if(operation === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.NewRequestBodyCommand#hasRequestBody(io.apicurio.datamodels.openapi.models.OasOperation)
     * @param {OasOperation} operation
     * @return {boolean}
     */
    hasRequestBody(operation : OasOperation) : boolean {
        return ModelUtils.isDefined(operation) && /* size */(<number>operation.getParametersIn("body").length) > 0;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.NewRequestBodyCommand#doCreateRequestBody(io.apicurio.datamodels.openapi.models.OasOperation)
     * @param {OasOperation} operation
     */
    doCreateRequestBody(operation : OasOperation) {
        if(this.isNullOrUndefined(operation.parameters)) {
            operation.parameters = <any>([]);
        }
        let param : Oas20Parameter = <Oas20Parameter>operation.createParameter();
        param.in = "body";
        param.name = "body";
        operation.addParameter(param);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.NewRequestBodyCommand#doRemoveRequestBody(io.apicurio.datamodels.openapi.models.OasOperation)
     * @param {OasOperation} operation
     */
    doRemoveRequestBody(operation : OasOperation) {
        let parameters : Array<OasParameter> = operation.getParameters();
        let bodyParams : Array<OasParameter> = operation.getParametersIn("body");
        for(let index126=0; index126 < bodyParams.length; index126++) {
            let bodyParam = bodyParams[index126];
            {
                /* remove */parameters.splice(parameters.indexOf(bodyParam), 1)[0];
            }
        }
        parameters = operation.getParameters();
        if(/* size */(<number>parameters.length) === 0) {
            NodeCompat.setProperty(operation, Constants.PROP_PARAMETERS, null);
        }
    }
}
NewRequestBodyCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.NewRequestBodyCommand_20";
NewRequestBodyCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




